import React from 'react';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'assets/icons';
import MuiButton from 'components/__v5__/Button/MuiButton';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import { useSignaturePreviewHooks } from '../../hooks/useSignaturePreviewHooks';
import { signatoryProps, SignatureFieldProps } from '../../type/preview.type';
import { SignatureCanvas } from '../../../components/SignatureCanvas/SignatureCanvas';
import { MultipleSignatureField } from '../../../components/MultipleSignatureField/MultipleSignatureField';

export const MultiSignatureFormFieldPreview = React.memo(
  ({
    element,
    handleDirty,
    tableId,
    rowIndex,
    colIndex,
    updateAnswer,
  }: SignatureFieldProps) => {
    const {
      signatories,
      errorMessage,
      addSignatory,
      isDialogOpen,
      sigCanvas,
      attachmentLoading,
      removeSignature,
      save,
      toggleSignaturePad,
      clear,
      setIsDialogOpen,
    } = useSignaturePreviewHooks(
      element,
      handleDirty,
      tableId,
      rowIndex,
      colIndex,
      updateAnswer,
    );

    return (
      <Box key={element?.id} m={1}>
        {!tableId && (
          <FieldsInputTitle
            label={element?.label || element?.name}
            isRequired={element?.isRequired}
          />
        )}
        <SignatureCanvas
          sigCanvas={sigCanvas}
          clear={clear}
          save={save}
          setIsDialogOpen={setIsDialogOpen}
          multi
          isDialogOpen={isDialogOpen}
        />
        {Array.isArray(signatories) &&
          signatories.map((signatory: signatoryProps) => (
            <Box key={signatory?.id}>
              <MultipleSignatureField
                signatory={signatory}
                removeSignature={removeSignature}
                toggleSignaturePad={toggleSignaturePad}
                attachmentLoading={attachmentLoading}
                isTable={!!tableId}
              />
            </Box>
          ))}
        <Typography variant="subtitle2" color="error">
          {errorMessage}
        </Typography>
        <Box mt={1}>
          <MuiButton
            variant="outlined"
            color="secondary"
            onClick={addSignatory}
            startIcon={<AddIcon />}
            disabled={attachmentLoading}
          >
            Add Signatory
          </MuiButton>
        </Box>
      </Box>
    );
  },
);
